import { Divider, Flex, Layout, Menu, Typography } from 'antd';
// @ts-ignore
import { ItemType } from 'antd/es/menu/hooks/useItems';
import { TFunction } from 'i18next';
import { Fragment, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import LeftIcon from 'src/assets/icons/left.png';
import RightIcon from 'src/assets/icons/right.png';
import urlPath from 'src/constants/urlPath';
import { AppContext } from 'src/contexts/app.context';
import { getLastItem, getPathsFromRoles } from 'src/utils/utils';
import Icon from '../Icon';
import './sidebar.scss';
const { Sider: SiderAntd } = Layout;
const { Text } = Typography;

type MenuItem = {
  label: React.ReactNode;
  key: React.Key;
  icon?: React.ReactNode;
  children?: MenuItem[];
  code?: string;
  type?: string;
};

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  path?: string[],
  type?: string
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    path,
    type
  } as MenuItem;
}

function getItemV1(label: React.ReactNode, key: React.Key, path?: string[]): MenuItem {
  return getItem(label, key, undefined, undefined, path);
}

const items = (t: TFunction<'translation', undefined, 'translation'>): ItemType[] => {
  return [
    getItem(
      'Theo dõi',
      'follow',
      null,
      [
        getItemV1(
          t(String(getLastItem(urlPath.receivePlan.path))),
          urlPath.receivePlan.location,
          urlPath.receivePlan.path
        ),

        getItemV1(t(String(getLastItem(urlPath.debt.path))), urlPath.debt.location, urlPath.debt.path),
        getItemV1(
          t(String(getLastItem(urlPath.ordersHistory.path))),
          urlPath.ordersHistory.location,
          urlPath.ordersHistory.path
        )
      ],
      [],
      'group'
    ),
    getItem(
      'Phiếu',
      'ticket',
      null,
      [
        // Commented out PSM purchase paths - removed from urlPaths/purchase.ts
        // getItemV1(
        //   t(String(getLastItem(urlPath.purchaseRequest.path))),
        //   urlPath.purchaseRequest.location,
        //   urlPath.purchaseRequest.path
        // ),
        // getItemV1(
        //   t(String(getLastItem(urlPath.purchaseQuotation.path))),
        //   urlPath.purchaseQuotation.location,
        //   urlPath.purchaseQuotation.path
        // ),
        // getItemV1(
        //   t(String(getLastItem(urlPath.purchaseOrderStamp.path))),
        //   urlPath.purchaseOrderStamp.location,
        //   urlPath.purchaseOrderStamp.path
        // ),
        // getItemV1(
        //   t(String(getLastItem(urlPath.purchaseOrder.path))),
        //   urlPath.purchaseOrder.location,
        //   urlPath.purchaseOrder.path
        // ),
        // getItemV1(t(String(getLastItem(urlPath.grpor.path))), urlPath.grpor.location, urlPath.grpor.path),
        // getItemV1(t(String(getLastItem(urlPath.grpo.path))), urlPath.grpo.location, urlPath.grpo.path)
        // getItemV1(t(String(getLastItem(urlPath.qcResult.path))), urlPath.qcResult.location, urlPath.qcResult.path),
        // getItemV1(t(String(getLastItem(urlPath.apInvoice.path))), urlPath.apInvoice.location, urlPath.apInvoice.path)
      ],
      [],
      'group'
    ),
    getItem(
      'Master data',
      'masterData',
      null,
      [
        getItemV1(
          t(String(getLastItem(urlPath.setOfDocument.path))),
          urlPath.setOfDocument.location,
          urlPath.setOfDocument.path
        ),
        getItemV1(
          t(String(getLastItem(urlPath.documentType.path))),
          urlPath.documentType.location,
          urlPath.documentType.path
        ),
        getItemV1(t(String(getLastItem(urlPath.refKey.path))), urlPath.refKey.location, urlPath.refKey.path)
      ],
      [],
      'group'
    )
  ];
};

export default function PsSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedKey, setSelectedKey] = useState<string>(location.pathname);

  const { roles, isSidebarCollapsed, setIsSidebarCollapsed } = useContext(AppContext);

  const paths = useMemo(() => {
    return getPathsFromRoles(roles);
  }, [roles]);

  const backTop = () => {
    const element = document.querySelector('html');
    if (element) {
      element.scrollTop = 10;
    }
  };

  const handleCollapse = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location.pathname]);

  return (
    <SiderAntd
      trigger={null}
      width={'260px'}
      collapsible
      collapsed={isSidebarCollapsed}
      collapsedWidth={50}
      className='sidebar-main no-subheader'
    >
      {!isSidebarCollapsed ? (
        <Fragment>
          <Flex justify='space-between' align='center' gap={10}>
            <Text strong className='sidebar-title'>
              Quản lý mua hàng
            </Text>
            <div className='menu-button menu-button-open' onClick={handleCollapse}>
              <Icon url={LeftIcon} size={20} titleTooltip='Menu' />
            </div>
          </Flex>
          <Divider dashed className='sidebar-title-divider' />

          <Menu
            selectedKeys={[selectedKey]}
            mode='inline'
            items={Array.isArray(paths) ? items(t) : []}
            style={{ marginTop: 20, borderRight: 0, minHeight: 100 }}
            onClick={({ key }) => {
              backTop();
              navigate(key);
            }}
          />
        </Fragment>
      ) : (
        <Fragment>
          <Flex
            justify='flex-end'
            align='center'
            gap={10}
            className='menu-button menu-button-open'
            onClick={handleCollapse}
          >
            <Icon
              url={RightIcon}
              size={20}
              titleTooltip='Xem menu'
              arrowTooltip={false}
              placementTooltip='right'
              styleTooltip={{ fontSize: '12px' }}
            />
          </Flex>
        </Fragment>
      )}
    </SiderAntd>
  );
}
